/**
 * Cmarkdownheading Component
 * Heading component for markdown rendering (h1-h6)
 */
"use client";
import type { ReactElement } from "react";
import { Ctext } from "../Ctext";
import { CmarkdownheadingAccentBar } from "./CmarkdownheadingAccentBar";
import { selectMarkdownHeadingModel } from "./markdown-heading-model";
import { createMarkdownHeadingTextStyle, createMarkdownHeadingWrapperStyle, } from "./markdown-heading-styles";
import type { CmarkdownheadingProps } from "./markdown-heading-types";
export type { CmarkdownheadingProps } from "./markdown-heading-types";
export function Cmarkdownheading({ children, preset, level, className, style, textAlign, hebrew = false, }: CmarkdownheadingProps): ReactElement {
    const model = selectMarkdownHeadingModel({ preset, level, textAlign, hebrew });
    const { config } = model;
    const wrapperStyle = createMarkdownHeadingWrapperStyle({
        config,
        languageMode: model.languageMode,
        style,
    });
    const textStyle = createMarkdownHeadingTextStyle({ config });
    return (
      <div className={className} style={wrapperStyle}>
        {config.accentBar ? (<CmarkdownheadingAccentBar accentBar={config.accentBar} size={config.size}/>) : null}
        <Ctext size={config.size} weight={model.resolvedWeight} color={config.color} opacity={config.opacity} align={model.resolvedAlign} style={textStyle}>
          {children}
        </Ctext>
      </div>
    );
}
